import { format } from 'date-fns';
import type { HandoffMessage } from '../../types/handoff';

type Props = {
  messages: HandoffMessage[];
};

function getSenderLabel(role: string) {
  switch (role) {
    case 'user':
      return 'Kund';
    case 'assistant':
      return 'AI';
    case 'agent':
      return 'Kundtjänst';
    case 'system':
      return 'System';
    default:
      return role;
  }
}

function getBubbleAlignment(role: string) {
  if (role === 'agent' || role === 'assistant') {
    return 'justify-end';
  }

  return 'justify-start';
}

function getBubbleStyle(role: string) {
  switch (role) {
    case 'agent':
      return 'bg-blue-600 text-white';
    case 'assistant':
      return 'bg-gray-900 text-white';
    case 'system':
      return 'bg-amber-50 text-amber-900 border border-amber-100';
    case 'user':
    default:
      return 'bg-white text-gray-950 border border-gray-200';
  }
}

export function HandoffMessageList({ messages }: Props) {
  if (messages.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-gray-200 bg-white p-6 text-center text-sm text-gray-500">
        Inga meddelanden ännu.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {messages.map((message) => (
        <div key={message.id} className={`flex ${getBubbleAlignment(message.role)}`}>
          <div className="max-w-[72%]">
            <div className="mb-1 flex items-center gap-2 text-xs text-gray-400">
              <span>
                {message.role === 'agent'
                  ? message.senderAlias || getSenderLabel(message.role)
                  : getSenderLabel(message.role)}
              </span>
              <span>{format(new Date(message.createdAt), 'HH:mm')}</span>
            </div>

            <div
              className={[
                'whitespace-pre-wrap rounded-2xl px-4 py-3 text-sm leading-6 shadow-sm',
                getBubbleStyle(message.role),
              ].join(' ')}
            >
              {message.content}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
